import React, { useEffect, useRef } from "react";

type CustomAlertProps = {
  message: string;
  onClose: () => void;
};

const CustomAlert: React.FC<CustomAlertProps> = ({ message, onClose }) => {
  const okButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (okButtonRef.current) {
      okButtonRef.current.focus()
    };
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  if (!message) {
    return null;
  }

  return (
    <div style={styles.overlay}>
      <div style={styles.centerBox}>
        <div style={styles.box} role="alertdialog" aria-modal="true">
          <div style={styles.message}>{message}</div>
          <button
            ref={okButtonRef}
            style={styles.button}
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  overlay: {
    position: "fixed",
    zIndex: 9999,
    left: 0, top: 0, width: "100vw", height: "100vh",
    background: "rgb(0 0 0 / 81%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  centerBox: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  box: {
    background: "#fff",
    borderRadius: 8,
    boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
    minWidth: "15rem",
    maxWidth: "30rem",
    padding: "1.5rem 1rem 1rem 1rem",
    textAlign: "center"
  },
  message: {
    marginBottom: 24,
    fontSize: 16,
    color: "#222"
  },
  button: {
    display: "inline-block",
    width: "30%",
    height: "40px",
    fontWeight: 400,
    color: "#fff",
    textAlign: "center",
    verticalAlign: "middle",
    userSelect: "none",
    backgroundColor: "#F40009",
    border: "1px solid transparent",
    padding: "0.375rem 0.75rem",
    fontSize: "0.9375rem",
    lineHeight: 1.5,
    borderRadius: 8,
    transition: "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out"

  }
};

export default CustomAlert;